const env = "production";
//const env = "staging";

const settings = {
  show_title: false,
  show_subtitle: false,
  show_order_detail: false,
  enable_auto_redirect: true,
};

export const config = {
  env,
  publicKey:
    env === "staging"
      ? "6LcVgSMrAAAAAC9y2XrxxM6dBFigL6aah6V7XUdh"
      : "6LeogzIrAAAAAD-emkoHY93BHlQrYhcYJIejc82W",
  settings,
  redirectUrl:
    "https://cicclodev.blob.core.windows.net/pages/pinklaundry/es-ar.html",
};
